// extracted by mini-css-extract-plugin
module.exports = {"input":"footer-module--input--2JWfa","inputGroup":"footer-module--inputGroup--2-1ur","submitButton":"footer-module--submitButton--14d--"};